import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ButtonSnippet from '../ButtonSnippet';
import Button from 'components/Button';

const Snippet = ({ versionId, token, onCancel, trackId }) => {
  const { t } = useTranslation();
  const [isGenerating, setIsGenerating] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const generateSnippet = () => {
    setIsGenerating(true);
    setDisabled(true);
    axios
      .get(`https://snippet-stg.chestmusic.com/shared/snippet?version_id=${versionId}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'video/mp4' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'video.mp4');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setDisabled(false);
        setIsGenerating(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className='share-container'>
        <h5 className='font-thunder-bold text-[36px] w-full text-center'>{t('share.snippet_title')}</h5>
        <div className='py-4 flex flex-col gap-y-6'>
          <p className='text-base text-neutral-silver-200'>{t('share.snippet_description')}</p>
          <div className='w-full items-center justify-center flex gap-5'></div>
        </div>
        <ButtonSnippet
          style='primary'
          loading={isGenerating}
          text={t('share.generate_snippet')}
          disabled={disabled}
          onClick={generateSnippet}
          customStyle='w-full '
        />
      </div>
      <div className='flex gap-4'>
        <Button
          style='tertiary'
          customStyle='lg:!w-[224px] mt-6 !mx-auto !w-10/12'
          text={t('share_screen.back_to_my_chest')}
          onClick={() => navigate('/my-chest')}
        />
        <Button
          style='tertiary'
          customStyle='lg:!w-[224px] mt-6 !mx-auto !w-10/12'
          text={t('share_screen.go_to_project')}
          onClick={() => navigate(`/my-chest/treasure/${trackId}`)}
        />
      </div>
    </>
  );
};

export default Snippet;
